export const floatToPercent = (num, digits = 0) => {
  const numAsPercent = num * 100;
  return `${numAsPercent.toFixed(digits)}`;
};

export const DateFormat = {
  PITCH_CRITERIA_DATE: "YYYY-MM-DD"
};



// WEBPACK FOOTER //
// ./src/utils/format.js